/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import styled from 'styled-components';

import { TABLE_FOOTER_BOTTOM_STYLE } from '../../../../components/Table/constants';

export const TableFooterStickyStyled = styled.div.attrs({
    className: 'table__table-footer sticky-footer',
})`
    position: sticky;
    bottom: ${TABLE_FOOTER_BOTTOM_STYLE}px;
`;
